import { useState } from 'react';
import { RolesApi } from '@/api/clients/roles/roles.api';

export const useDeleteRole = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const deleteRole = async (roleId) => {
    setLoading(true);
    setError(null);

    try {
      const response = await RolesApi.deleteRole(roleId);
      return response.data?.data || response.data;
    } catch (err) {
      const errorMessage =
        err.response?.data?.message || 'Failed to delete role';
      setError(errorMessage);
      console.error('Error deleting role:', err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const clearError = () => {
    setError(null);
  };

  return {
    deleteRole,
    loading,
    error,
    clearError,
  };
};
